import {
  ControlGroup,
  FormGroup,
  // H1,
  HTMLSelect,
  InputGroup,
  Tag,
  // IOptionProps,
} from "@blueprintjs/core";

import "@blueprintjs/core/lib/css/blueprint.css";
import * as React from "react";
import { firestore } from "../firebase";

const tagStyle = {
  backgroundColor: "#0D47F0"
};
const tagNumStyle = {
  backgroundColor: "white"
};
const TagStyletotal = {
  backgroundColor: "red"
};
interface Sites {
  label:undefined | string;
  value:number | string
}

interface Business{
  businessId: null | string;
  businessName: string;
  dailyCheckIns:null | number;
  dailyOptOuts:null | number;
  sites: Sites[];
  sitesId:null | string;
}


interface State{
  businessData: Business[],
}

class Dashboard extends React.Component<any, State> {
  public state:State = {
      businessData : [],
  }


  public componentDidMount(){
      this.initDashboard();
  }

  public get_total(){
    const { businessData } = this.state;
    let total=0;

    businessData.sort(
      ({ businessName: pathA }, { businessName: pathB }) =>
        pathA === pathB ? 0 : pathA > pathB ? 1 : -1
    ).map((bData,index)=>{
      total +=bData.dailyOptOuts==null ? 0 : bData.dailyOptOuts;

    });

return total;

  }


  public get_total_daily_count(){
    const { businessData } = this.state;
    let totalt=0;

    businessData.sort(
      ({ businessName: pathA }, { businessName: pathB }) =>
        pathA === pathB ? 0 : pathA > pathB ? 1 : -1
    ).map((bData,index)=>{
      totalt +=bData.dailyCheckIns==null ? 0 : bData.dailyCheckIns;

    });

return totalt;

  }


  
  public render(){
      const { businessData } = this.state;
      return(
          <div id="dashboard-block">
          {businessData.sort(
              ({ businessName: pathA }, { businessName: pathB }) =>
                pathA === pathB ? 0 : pathA > pathB ? 1 : -1
            ).map((bData,index)=>(
              <div id="dashboard-inner-block">
                  <ControlGroup>
                  <FormGroup><InputGroup placeholder="Placeholder text" value={bData.businessName?bData.businessName:''} disabled={true} /></FormGroup>
                  <HTMLSelect
                      data-key={index}
                      // className={hideSites ? Hidden : undefined}
                      onChange={this.handleSite}
                      options={
                          [{ label: "all", value: "all" },...bData.sites]
                      }
                      value={bData.sitesId || 'all'}
                  />
                  </ControlGroup>
                  <br />
                  <ControlGroup>
                      <div id="dashboard-daily-cnt-style">
                      <Tag style={tagStyle} large={true}>Daily Count</Tag>
                      <Tag style={tagNumStyle} large={true} minimal={true}>
                          {bData.dailyCheckIns}
                      </Tag>
                      </div>
                      &nbsp;
                      <div id="dashboard-daily-kisk-style">
                      <Tag style={tagStyle} large={true}>Daily Kiosk Opt-Outs</Tag>
                      <Tag style={tagNumStyle} large={true} minimal={true}>
                          {bData.dailyOptOuts}
                      </Tag>
                      </div>
                  </ControlGroup>
              </div>
          ))}


<ControlGroup>
{this.get_total_daily_count() ?  <div id="dashboard-daily-cnt-style">
                      <Tag style={TagStyletotal} large={true}>Total Daily Count</Tag>
                      <Tag style={tagNumStyle} large={true} minimal={true}>
                      {this.get_total_daily_count() ? this.get_total_daily_count()  : 0  }
                      </Tag>
                      </div> :''}
                      &nbsp;
                      {this.get_total() ? <div id="dashboard-daily-kisk-style">
                      <Tag style={TagStyletotal} large={true}>Total Daily Kiosk Opt-Outs</Tag>
                      <Tag style={tagNumStyle} large={true} minimal={true}>
                      {this.get_total() ? this.get_total()  : 0}
                      </Tag>
                      </div> :''}
                  </ControlGroup>

          </div>
      )    
  }


  private handleSite = async (currentTarget: React.ChangeEvent<HTMLSelectElement>) => {
      const sId = currentTarget.target.value;
      const index = currentTarget.target.getAttribute('data-key');
      if(index != null){
          const dailyCheckIns = await this.getDailyCount(this.state.businessData[index].businessId, sId);
          const dailyOptOuts = await this.watchOptOutsCount(this.state.businessData[index].businessId, sId);
          const businessData = Object.assign(this.state.businessData);
          businessData[index].sitesId = sId;
          businessData[index].dailyCheckIns = dailyCheckIns;
          businessData[index].dailyOptOuts = dailyOptOuts;
          this.setState({ businessData });
      }
    };

    private async getDailyCount(businessId,siteId){
      let dailyCount = 0;  
      const today = new Date();
      let dd: any = today.getDate();
      let mm: any = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      if (dd < 10) {
      dd = "0" + dd;
      }

      if (mm < 10) {
      mm = "0" + mm;
      }
      const date = mm + "-" + dd + "-" + yyyy;    

      if (siteId && siteId !== "all") {
          await firestore
          .collection("checkIns")
          .where("businessId", "==", businessId)
          .where("siteId", "==", siteId)
          .where("timestamp", ">=", new Date(date))
          .get()
          .then(snap => {
              dailyCount = snap.size;
          });
      } else if (siteId === "all") {
          await firestore
          .collection("checkIns")
          .where("businessId", "==", businessId)
          .where("timestamp", ">=", new Date(date))
          .get()
          .then(snap => {
              dailyCount = snap.size;
          });
      }
      return dailyCount;

  }
  
  private watchOptOutsCount = async (businessId, siteId) => {
      let dailyOptOuts = 0;
      if (businessId === "VQMWUEYKKs4rSpAzQ7P2") {
        console.log("WAP...");
        dailyOptOuts = await this.watchWrenchAPartOptOutsCount(businessId, siteId);
        return dailyOptOuts;
      }
      const now = new Date();
      const lastMidnight = now.setHours(0, 0, 0, 0);
      console.log(lastMidnight);
  
      // then convert those to UTC0 to pass on in your query to firestore
      // const lastMidNightUTC = new Date(lastMidnight + now.getTimezoneOffset() * 60000).toString();
      const today = new Date();
      let dd: any = today.getDate();
      let mm: any = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
  
      if (mm < 10) {
        mm = "0" + mm;
      }
      const date = mm + "-" + dd + "-" + yyyy;
  
      console.log("DAILY OPT OUTS");
      if (siteId && siteId !== "all") {
        await firestore
          .collection("checkIns")
          .where("businessId", "==", businessId)
          .where("siteId", "==", siteId)
          .where("userId", "==", "opt-out")
          .where("timestamp", ">=", new Date(date))
          .get()
          .then((snap) => {
            dailyOptOuts = snap.size;
          });
      } else if (siteId === "all") {
        console.log("finding size...");
        await firestore
          .collection("checkIns")
          .where("businessId", "==", businessId)
          .where("userId", "==", "opt-out")
          .where("timestamp", ">=", new Date(date))
          .get()
          .then((snap) => {
            dailyOptOuts = snap.size;
          });
      }
      return dailyOptOuts;
    };
      
    private watchWrenchAPartOptOutsCount = async (businessId, siteId) => {
      let dailyOptOuts = 0;
      const now = new Date();
      const lastMidnight = now.setHours(0, 0, 0, 0);
      console.log(lastMidnight);
  
      // then convert those to UTC0 to pass on in your query to firestore
      // const lastMidNightUTC = new Date(lastMidnight + now.getTimezoneOffset() * 60000).toString();
      const today = new Date();
      let dd: any = today.getDate();
      let mm: any = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
  
      if (mm < 10) {
        mm = "0" + mm;
      }
      const date = mm + "-" + dd + "-" + yyyy;
  
      if (siteId && siteId !== "all") {
        await firestore
          .collection("checkIns")
          .where("businessId", "==", businessId)
          .where("siteId", "==", siteId)
          .where("optin", "==", false)
          .where("timestamp", ">=", new Date(date))
          .get()
          .then((snap) => {
            dailyOptOuts = snap.size;
          });
      } else if (siteId === "all") {
        console.log("finding size...");
        firestore
          .collection("checkIns")
          .where("businessId", "==", businessId)
          .where("optin", "==", false)
          .where("timestamp", ">=", new Date(date))
          .get()
          .then((snap) => {
            dailyOptOuts = snap.size;
          });
      }
      return dailyOptOuts;
    };

  private async getSites(businessId){
      const siteDta : Sites[] = [];
      await firestore
      .collection(`businesses/${businessId}/sites`)
      .get()       
      .then((sites) => {
          
          sites.forEach((sdoc) => {
              siteDta.push({ label: sdoc.data().path, value: sdoc.id });
          })
      });
      return siteDta;
  }

  private async initDashboard() {
      let allBusinessData:any = [];
      await firestore
      .collection("businesses")
      .get()
      .then((snap) =>{
          const filterBus : any = [];
          snap.forEach(doc=>{
              if(!doc.data().isArchive){
                  filterBus.push(doc.data());
              }
          });
          const sortedBus = filterBus.sort(
              ({ path: pathA }, { path: pathB }) =>
                pathA === pathB ? 0 : pathA > pathB ? 1 : -1
            );
          allBusinessData = sortedBus;

      });
      allBusinessData.forEach(async(doc) => {
          
          const siteDta  = await this.getSites(doc.businessId);
          const dailyCount = await this.getDailyCount(doc.businessId,'all');
          const dailyOptOut = await this.watchOptOutsCount(doc.businessId,'all');
          const businessData = {
              businessId:doc.businessId,
              businessName:doc.path,
              dailyCheckIns:dailyCount,
              dailyOptOuts:dailyOptOut,
              sites:siteDta,
              sitesId:"all"
          }
          this.setState(prevState => ({
              businessData: [...prevState.businessData, businessData]
          }));

      });

  }

}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/views/Dashboard.tsx